import { render } from "./RelativesTab.vue?vue&type=template&id=3a790b43"
import script from "./RelativesTab.vue?vue&type=script&lang=js"
export * from "./RelativesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__